import { Component } from "react";
import { Column } from "primereact/column";
import BetterCircularProgress from "../../components/BetterCircularProgress";
import { Group } from "@material-ui/icons";
import Button from "../../components/Button";
import BetterDataTable from "../../components/BetterDataTable";
import * as equipe from "../../crud/equipe.crud";
import styles from "../../styles/Equipe.module.scss";
import InputCustom from "../../components/InputCustom";

export default class EquipeIndex extends Component {
    state = {
        total: null,
        filtro_global: "",
        refresh: false,
    };

    componentDidMount() {
        equipe.getDataTable({ rows: 1, page: 0 })
            .then((res) => {
                this.setState({ total: res.data.data.total });
            })
            .catch(() => {
                this.setState({ total: 0 });
            });
    }

    fetchEquipe = (event) => {
        return equipe.getDataTable({ ...event, globalFilter: this.state.filtro_global })
            .then((res) => {
                this.setState({ total: res.data.data.total });

                return res;
            });
    };

    debounce_busca = null;

    handleBuscar = (valor) => {
        this.setState({ filtro_global: valor });

        clearTimeout(this.debounce_busca);

        this.debounce_busca = setTimeout(() => {
            this.setState({ refresh: true });
        }, 350);
    };

    handleDeletar = (id) => equipe.destroy(id);

    render() {
        const { total, filtro_global, refresh } = this.state;

        if (total === null) {
            return (
                <BetterCircularProgress loading={true} />
            );
        }

        if (total === 0 && !filtro_global) {
            return (
                <div>
                    <p className={styles.tituloPagina}>Equipe</p>

                    <div className={styles.emptyState}>
                        <span className={styles.emptyStateIcone}>
                            <Group style={{ fontSize: 56 }} />
                        </span>

                        <p>Nenhum usuário encontrado</p>
                        <span>Cadastre os membros da sua equipe para solicitar viagens.</span>

                        <Button
                            type="button"
                            variant="primary"
                            size="md"
                            onClick={() => this.props.history.push("/equipe/novo")}
                        >
                            Novo membro +
                        </Button>
                    </div>
                </div>
            );
        }

        return (
            <div className={styles.container}>
                <div className={styles.cabecalho}>
                    <p className={styles.tituloPagina}>Equipe</p>
                </div>

                <div className={styles.barraBusca}>
                    <div style={{ flex: 1, maxWidth: 400 }}>
                        <InputCustom
                            icon_right={<span class="material-symbols-outlined color-gray-7">search</span>}
                            placeholder="Pesquisar por nome do membro"
                            value={filtro_global}
                            onChange={(e) => this.handleBuscar(e.target.value)}
                        />
                    </div>

                    <Button
                        type="button"
                        variant="primary"
                        size="md"
                        onClick={() => this.props.history.push("/equipe/novo")}
                        children="Novo membro&nbsp;&nbsp;+"
                    />
                </div>
                
                <BetterDataTable
                    fetchEvent={this.fetchEquipe}
                    refresh={refresh}
                    setRefresh={(valor) => this.setState({ refresh: valor })}
                    opcoesCrud
                    crudUrl="/equipe"
                    deleteHandler={this.handleDeletar}
                >
                    <Column field="usr_nome" header="Nome" />
                    <Column field="email" header="E-mail" />
                </BetterDataTable>
            </div>
        );
    }
}
